// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: '88da9428-8d6c-4520-8889-1d958ba67792',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '3a0a7a42-70f7-4204-880c-8b760d500681',
      type: 'Sprite',
      name: 'glow',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0.7,
      visible: true,
      tint: 16762112,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Circle_Glow',
      parent: '88da9428-8d6c-4520-8889-1d958ba67792'
    },
    {
      id: '85f86ebd-c59c-4522-9f35-108fa8cc838d',
      type: 'Sprite',
      name: 'coin',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Fly_Part_1',
      parent: '88da9428-8d6c-4520-8889-1d958ba67792'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  animations: [
    {
      id: '6331607a-3feb-4c42-851f-6989fac0e906',
      name: 'Turn_Around',
      playingSpeed: 2.5,
      totalDuration: 800,
      blocks: [
        {
          id: '6415ba82-309b-4ea9-bf5e-dc17f9504980',
          type: 'Setter',
          name: 'Coin1',
          track: 2,
          target: {
            textureName: 'Coin_Fly_Part_1'
          },
          startAt: 0,
          sourceName: 'coin',
          disabled: false
        },
        {
          id: 'fc99f605-e7cd-45e7-8aca-a6994c12ffe9',
          type: 'Setter',
          name: 'Glow1',
          track: 4,
          target: {
            scale: {
              x: 1
            }
          },
          startAt: 1,
          sourceName: 'glow',
          disabled: false
        },
        {
          id: '9753cc34-3fbe-456f-b6d5-3ba2b57cbd0e',
          type: 'Setter',
          name: 'Glow1_copy',
          track: 4,
          target: {
            scale: {
              x: 0.9
            }
          },
          startAt: 100,
          sourceName: 'glow',
          disabled: false
        },
        {
          id: '6a4a70fa-f624-4b5b-9dfc-2835eac13948',
          type: 'Setter',
          name: 'Coin2',
          track: 2,
          target: {
            textureName: 'Coin_Fly_Part_2'
          },
          startAt: 100,
          sourceName: 'coin',
          disabled: false
        },
        {
          id: '048d4b53-7af8-4a16-851e-c8cabdfd6de0',
          type: 'Setter',
          name: 'Glow1_copy_copy',
          track: 4,
          target: {
            scale: {
              x: 0.75
            }
          },
          startAt: 200,
          sourceName: 'glow',
          disabled: false
        },
        {
          id: '5b194c08-7e07-4714-af79-a2fd0d4344f6',
          type: 'Setter',
          name: 'Coin3',
          track: 2,
          target: {
            textureName: 'Coin_Fly_Part_3'
          },
          startAt: 200,
          sourceName: 'coin',
          disabled: false
        },
        {
          id: 'd7c6189f-5af2-42cc-a158-0e85e94df288',
          type: 'Setter',
          name: 'Glow1_copy_copy_copy',
          track: 4,
          target: {
            scale: {
              x: 0.6
            }
          },
          startAt: 300,
          sourceName: 'glow',
          disabled: false
        },
        {
          id: 'a233c0d6-f547-4e82-a300-184c771991c8',
          type: 'Setter',
          name: 'Coin4',
          track: 2,
          target: {
            textureName: 'Coin_Fly_Part_4'
          },
          startAt: 300,
          sourceName: 'coin',
          disabled: false
        },
        {
          id: '38c7e64e-afc2-40e7-923a-d62be644f8ad',
          type: 'Setter',
          name: 'Glow5',
          track: 4,
          target: {
            scale: {
              x: 0.5
            }
          },
          startAt: 400,
          sourceName: 'glow',
          disabled: false
        },
        {
          id: '86ecb43a-90b1-4774-bdff-38c350203939',
          type: 'Setter',
          name: 'Coin5',
          track: 2,
          target: {
            textureName: 'Coin_Fly_Part_5'
          },
          startAt: 400,
          sourceName: 'coin',
          disabled: false
        },
        {
          id: 'f56a3124-fa4f-490c-bbc3-23a94eb2515a',
          type: 'Setter',
          name: 'Glow5_copy',
          track: 4,
          target: {
            scale: {
              x: 0.6
            }
          },
          startAt: 500,
          sourceName: 'glow',
          disabled: false
        },
        {
          id: 'e054b415-d571-4ba8-934b-a895f28fd975',
          type: 'Setter',
          name: 'Coin6',
          track: 2,
          target: {
            textureName: 'Coin_Fly_Part_6'
          },
          startAt: 500,
          sourceName: 'coin',
          disabled: false
        },
        {
          id: '8ff6af35-5cff-4dd0-9b4e-24c4e617d72c',
          type: 'Setter',
          name: 'Glow5_copy_copy',
          track: 4,
          target: {
            scale: {
              x: 0.75
            }
          },
          startAt: 600,
          sourceName: 'glow',
          disabled: false
        },
        {
          id: 'cab07406-7e42-4521-8721-cc55bec9ef1b',
          type: 'Setter',
          name: 'Coin7',
          track: 2,
          target: {
            textureName: 'Coin_Fly_Part_7'
          },
          startAt: 600,
          sourceName: 'coin',
          disabled: false
        },
        {
          id: 'f8a57e29-3f14-45e5-9d08-412383ed62b2',
          type: 'Setter',
          name: 'Glow5_copy_copy_copy',
          track: 4,
          target: {
            scale: {
              x: 0.9
            }
          },
          startAt: 700,
          sourceName: 'glow',
          disabled: false
        },
        {
          id: '39f60a8a-600b-42dc-b3f9-6940217ceaae',
          type: 'Setter',
          name: 'Coin8',
          track: 2,
          target: {
            textureName: 'Coin_Fly_Part_8'
          },
          startAt: 700,
          sourceName: 'coin',
          disabled: false
        },
        {
          id: '462756b6-71db-49d6-8587-741282305adc',
          type: 'Setter',
          name: 'Glow1_copy_1',
          track: 4,
          target: {
            scale: {
              x: 1
            }
          },
          startAt: 799,
          sourceName: 'glow',
          disabled: false
        },
        {
          id: 'e000819d-ac8f-4f63-8ffe-693c4164730b',
          type: 'Setter',
          name: 'Coin1_copy',
          track: 2,
          target: {
            textureName: 'Coin_Fly_Part_1'
          },
          startAt: 799,
          sourceName: 'coin',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class CoinPartLayout {
  static raw = raw;
  root!: Container;
  glow!: Sprite;
  coin!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Turn_Around {
  Layout: {
    coin: object;
    glow: object;
  };

  BlockTypeByName: {
    Coin1: object;
    Glow1: object;
    Glow1_copy: object;
    Coin2: object;
    Glow1_copy_copy: object;
    Coin3: object;
    Glow1_copy_copy_copy: object;
    Coin4: object;
    Glow5: object;
    Coin5: object;
    Glow5_copy: object;
    Coin6: object;
    Glow5_copy_copy: object;
    Coin7: object;
    Glow5_copy_copy_copy: object;
    Coin8: object;
    Glow1_copy_1: object;
    Coin1_copy: object;
  };

  flowData = raw.animations[0];
}
